export enum enumBillItemDescription {
  ISF = 'ISF',
  SELF_ENTRY = 'Self Entry',
  BROKER_ENTRY = 'Broker Entry',
  ADDITIONAL_LINES = 'Additional lines',
  ES_DUTIES = 'Duties and Fees',
  ISF_SINGLE_BOND = 'Single ISF Bond',
  ES_SINGLE_BOND = 'Single Entry Bond',
  ADDITION_TO_ENTRY_BOND = 'Addition to Entry Bond',
  ADDITIONAL_INVOICES = 'Additional invoices',
  COLLECTION_FEE = 'Collection Fee',
  CONTINUOUS_ANNUAL_BOND = 'Continuous Annual Bond',
  FWS = 'FWS',
  OTHER_PGA = 'Other PGAs',
  OTHER_ADDITIONAL_PAYMENT = 'Other Additional Payment',
  SALES_TAX = 'Sales tax',
  ADDITIONAL_CUSTOMS_DUTIES = 'Additional Customs Duties',
  ADDITIONAL_ENTRY_HANDLING = 'Additional Entry Handling',
  DISCOUNT = 'Discount',
  ORIGIN_CBM = 'Origin CBM',
  ORIGIN_HBL = 'Origin HBL',
  FREIGHT = 'Freight',
  DESTINATION_CBM = 'Destination CBM',
  DESTINATION_HBL = 'Destination HBL',
  EXPORT_LICENSE = 'Export license',
  LOADING_FEES = 'Loading fees',
  UNLOADING_FEES = 'Unloading fees',
  ADDITIONAL_CHARGES = 'Additional changes',
  STORAGE = 'Storage',
  LATE_BROKER_ENTRY = 'Late Broker Entry',
  TRUCKER_BROKER_ENTRY = 'Trucker ES',
  /** @deprecated Retained only to render historical bills from when the deposit feature was active. */
  TRUCKER_DEPOSIT = 'Cross-border deposit',
  POA = 'Power of Attorney',
  MARINE_INSURANCE = 'Marine insurance',
  MARINE_INSURANCE_PROCESSING = 'Marine insurance processing',
  ASSIGNED_CBP_NUMBER_REQUEST = 'Assigned CBP Requests',
}
